import { Box, Typography } from "@mui/material"
import uiucCampus from './uiucBackground.jpg'
import Seal from './UiucSeal'
const Mast: React.FC = () => {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}>
        <Box
        sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: '64px',
                marginBottom: "64px",
                borderRadius: '400px',
                padding: '64px',
                width: '50%',
                backgroundImage: `url(${uiucCampus})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
      ><Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto',
        justifyContent: 'center'
      }}>
        <Typography variant="h4" color="primary" sx={{ textAlign: 'center'}}>
        University of Illinois <br />
        Urbana-Champaign
      </Typography>
      <Box sx={{
        display: 'flex',
        justifyContent: "center",
        marginTop: '24px'
      }}>
     <Seal />
     </Box>
     </Box>
     </Box>  
           </Box>
    )
}
export default Mast;